import React ,{ Suspense, lazy }from 'react'

import "@fontsource/mulish";
import Homepage from "./pages/index";
import Header  from './components/Header';
import { HelmetProvider } from 'react-helmet-async';
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";
import { buildVersion } from './services/buildInfo';
import {useEffect} from 'react';
// import Thankyou from "./pages/thankyou";
const ThankYou = lazy(() => import("./pages/thankyou.js"));

function App() {

  useEffect(() => {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
      event: "pageView",
      web: {
        webPageDetails: {
          pageViews: {
            value: 1,
          },
          URL: window.location.href,
          isErrorPage: false,
          name: "icicibank:in:en:campaign:loans:goldloan:goldloan:onboarding:landing page",
        },
      },
      _icicibank: {
        channelInfo: {
          version: buildVersion,
          name: "NLI",
        },
        
        pageInfo: {
          "language": "en", "country": "in", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na","subSubJourney": "na",
          virtualPageName: "icicibank:in:en:campaign:loans:goldloan:goldloan:onboarding:landing page",
        },
      },
    });

  }, [])
  
  return (
    <>
      <HelmetProvider>
       {/* update basename while pushing to UAT/LIVE {UAT: /v2/46725/lp/casa/goldLoan/main, live:window.location.pathname } */}
        <Router basename={window.location.pathname}>
        <Header path="./dist/img/icici_logo.webp" />
          <Routes>
            <Route path="/" element={<Homepage />} />
            {/* <Route path="/thankyou" element={<Thankyou />} /> */}
            <Route path="/thankyou" element={(
            <Suspense fallback={<h1>Loading...</h1>}>
              < ThankYou />
            </Suspense>
          )} />
          </Routes>
        </Router>
      </HelmetProvider>

    </>
  );
}

export default App;
